/* AK Bodyfashion · scripts voor de v0.2-secties. Zonder afhankelijkheden. Alles werkt ook zonder JavaScript. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Slideshow ---------- */
  function initSlider(root) {
    if (root.dataset.aksReady) return;
    root.dataset.aksReady = '1';
    var track = root.querySelector('[data-aks-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-aks-slide]'));
    if (!track || slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-aks-dot]'));
    var counter = root.querySelector('[data-aks-counter]');
    var pauseBtn = root.querySelector('[data-aks-pause]');
    var delay = Math.max(3, parseInt(root.dataset.speed || '6', 10)) * 1000;
    var autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
    var current = 0, timer = null, userPaused = false, hovering = false;

    function go(i, smooth) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function mark(i) {
      current = i;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      slides.forEach(function (s, n) { s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); s.toggleAttribute('inert', n !== i); });
      if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!autoplay || userPaused || hovering || document.hidden) return;
      timer = setInterval(function () { go(current + 1); }, delay);
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current && slides[i]) mark(i);
      });
    }, { passive: true });

    root.querySelectorAll('[data-aks-prev]').forEach(function (b) { b.addEventListener('click', function () { go(current - 1); start(); }); });
    root.querySelectorAll('[data-aks-next]').forEach(function (b) { b.addEventListener('click', function () { go(current + 1); start(); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    if (pauseBtn) {
      if (!autoplay) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? 'Diavoorstelling afspelen' : 'Diavoorstelling pauzeren');
        userPaused ? stop() : start();
      });
    }
    root.addEventListener('mouseenter', function () { hovering = true; stop(); });
    root.addEventListener('mouseleave', function () { hovering = false; start(); });
    root.addEventListener('focusin', function () { hovering = true; stop(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { hovering = false; start(); } });
    track.addEventListener('touchstart', function () { stop(); }, { passive: true });
    track.addEventListener('touchend', function () { start(); }, { passive: true });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(current + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(current - 1); e.preventDefault(); }
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    window.addEventListener('resize', function () { go(current, false); });

    mark(0);
    start();
  }

  /* ---------- Megamenu: Escape sluit, klik op touch opent eerst ---------- */
  function initMega() {
    var items = document.querySelectorAll('.nav-item.has-mega, .nav-item.has-children');
    var touch = window.matchMedia('(hover: none)').matches;
    items.forEach(function (item) {
      var link = item.querySelector(':scope > a');
      if (!link) return;
      link.setAttribute('aria-expanded', 'false');
      item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
      if (touch) {
        link.addEventListener('click', function (e) {
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            items.forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.activeElement && document.activeElement.closest('.nav-item');
      if (open) {
        open.classList.remove('is-open');
        var l = open.querySelector(':scope > a');
        if (l) { l.setAttribute('aria-expanded', 'false'); l.focus(); l.blur(); }
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-item')) items.forEach(function (o) { o.classList.remove('is-open'); });
    });
  }

  /* ---------- Merken A-Z zoeken ---------- */
  function initBrandSearch(root) {
    var input = root.querySelector('[data-aks-brand-search]');
    if (!input || input.dataset.aksReady) return;
    input.dataset.aksReady = '1';
    var groups = root.querySelectorAll('[data-aks-group]');
    var empty = root.querySelector('[data-aks-empty]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      var any = false;
      groups.forEach(function (g) {
        var visible = 0;
        g.querySelectorAll('li').forEach(function (li) {
          var name = (li.dataset.name || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
          var show = !q || name.indexOf(q) > -1;
          li.hidden = !show;
          if (show) visible++;
        });
        g.hidden = visible === 0;
        if (visible) any = true;
      });
      if (empty) empty.hidden = any;
    });
  }

  /* ---------- Tabbladen (Shop op maat) ---------- */
  function initTabs(root) {
    if (root.dataset.aksReady) return;
    root.dataset.aksReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role=tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role=tabpanel]'));
    panels.forEach(function (p) { if (p.hasAttribute('data-aks-hidden')) p.hidden = true; });
    function select(i, focus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[n]) panels[n].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { select(n); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { select((n + 1) % tabs.length, true); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { select((n - 1 + tabs.length) % tabs.length, true); e.preventDefault(); }
      });
    });
    root._aksSelect = select;
  }

  /* ---------- Link kopieren ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aks-copy]');
    if (!btn) return;
    var url = btn.dataset.aksCopy || location.href;
    var done = function () {
      var old = btn.textContent;
      btn.textContent = 'Link gekopieerd';
      setTimeout(function () { btn.textContent = old; }, 2000);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
  });

  /* ---------- Video pauzeren / afspelen in beeld ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aks-video-toggle]');
    if (!btn) return;
    var video = btn.closest('[data-aks-video]').querySelector('video');
    if (!video) return;
    if (video.paused) { video.dataset.userPaused = ''; video.play(); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Video pauzeren'); }
    else { video.dataset.userPaused = '1'; video.pause(); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Video afspelen'); }
  });

  var videoObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { if (!v.dataset.userPaused && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      else if (!v.paused) v.pause();
    });
  }, { threshold: 0.25 }) : null;

  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-aks-video] video').forEach(function (v) {
      v.muted = true;
      if (reduceMotion) {
        v.dataset.userPaused = '1';
        var btn = v.closest('[data-aks-video]').querySelector('[data-aks-video-toggle]');
        if (btn) { btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Video afspelen'); }
      }
      if (videoObserver) videoObserver.observe(v); else if (!reduceMotion) v.play();
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-aks-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-aks-brands]').forEach(initBrandSearch);
    scope.querySelectorAll('[data-aks-tabs]').forEach(initTabs);
    initVideos(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initMega(); });
  } else { initAll(); initMega(); }

  /* Theme editor: secties opnieuw opbouwen na wijzigen */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[role=tab]');
    if (tab) {
      var root = tab.closest('[data-aks-tabs]');
      var all = Array.prototype.slice.call(root.querySelectorAll('[role=tab]'));
      if (root._aksSelect) root._aksSelect(all.indexOf(tab));
    }
    var slide = e.target.closest && e.target.closest('[data-aks-slide]');
    if (slide) {
      var track = slide.parentElement;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    }
  });
})();
